import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './styles.module.css';
import {
  CheckIcon,
  Dropper,
  NavigateArrowLeft,
  Trash,
} from '../../../assets/svgs/icons';
import ColorPaletteComponent from './ColorPaletteComponent';
import { notifyErrorCustom } from '../../../utils/notify';
import { BrandingService, OrchestratorColorsService, PythonService } from '../../../services';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FooterNaviBar } from '../../../components/FooterNaviBar';
import ColorPaletteComponentMobile from './ColorPaletteComponentMobile';
import PropTypes from 'prop-types'

const STEPS = {
  STEP_PASS_NICHE_AND_OBJECTIVE: 'stepNIcheAndObjective',

  STEP_PASS_TYPOGRAPHY: 'stepTypography',

  STEP_BRANDING: 'stepBranding',
};
function StepColorPalette({
  setStep,
  colors,
  setColors,
  businessAccountData,
  changesStep,
}) {
  const [branding, setBranding] = useState();
  const location = useLocation();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isVisualIdentityFlow = location.pathname === '/FastPublishing1';
  const stepsArray = [
    {
      pass: '1º Passo',
      title: 'Nicho e Objetivo',
      current: true,
    },
    {
      pass: '2º Passo',
      title: 'Paleta de cores',
      current: true,
    },
    {
      pass: '3º Passo',
      title: 'Fontes',
      current: false,
    },
    {
      pass: '4º Passo',
      title: 'BPS',
      current: false,
    },
    {
      pass: '5º Passo',
      title: 'Tom de Voz',
      current: false,
    },
    {
      pass: '6º Passo',
      title: 'Objetivo',
      current: false,
    },
    {
      pass: '7º Passo',
      title: 'Logo',
      current: false,
    },
    {
      pass: '8º Passo',
      title: 'Imagem',
      current: false,
    },
    {
      pass: '9º Passo',
      title: 'Geração de Arte',
      current: false,
    },
    {
      pass: '10º Passo',
      title: 'Download',
      current: false,
    },
  ];

  useEffect(() => {
    loadBranding();
  }, []);

  const loadBranding = async () => {
    // setColors(['#aa3333', '#aa3333'])
    const { data } = await BrandingService.getAllBrandingByBusinessId(
      businessAccountData?.data?.uuid ?? businessAccountData?.data[0]?.uuid
    );
    if (data.length > 0) {
      const values = [];
      if (data[0]?.primaryColor) {
        values.push(data[0]?.primaryColor);
      }
      if (data[0]?.secondaryColor) {
        values.push(data[0]?.secondaryColor);
      }
      if (data[0]?.tertiaryColor) {
        values.push(data[0]?.tertiaryColor);
      }
      if (data[0]?.complementaryColor1) {
        values.push(data[0]?.complementaryColor1);
      }
      if (data[0]?.complementaryColor2) {
        values.push(data[0]?.complementaryColor2);
      }
      while (values.length < 3) {
        values.push('');
      }
      setColors(values);
    } else {
      setColors(['', '', '']);
    }

    setBranding(data[0]);
  };

  const hexToRgb = (hexValue) => {
    // Remove o "#" se estiver presente
    const cleanHex = hexValue.replace('#', '');

    if (cleanHex.length !== 6) {
      return 'Formato inválido';
    }

    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);

    return `(${r}, ${g}, ${b})`;
  };

  const rgbToHex = (rgbValue) => {
    // console.log('rgb value', rgbValue)
    // Extrai os números da string rgb usando regex
    const result = rgbValue.match(/\d+/g);

    if (!result || result.length !== 3) {
      return 'Formato inválido';
    }

    const r = parseInt(result[0], 10);
    const g = parseInt(result[1], 10);
    const b = parseInt(result[2], 10);

    if ([r, g, b].some((v) => isNaN(v) || v < 0 || v > 255)) {
      return 'Valores fora do intervalo RGB';
    }

    const toHex = (num) => num.toString(16).padStart(2, '0');

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  const handleNavigate = async (type) => {
    // console.log('lol', colors[4]);

    if (type === 'next') {
      let generateColorReturn;
      // console.log('colorscolors', colors);
      if (colors.length < 3) {
        notifyErrorCustom(t('fast_publishing_choose_at_least_3_colors'));
        return;
      }

      if (colors.length === 3 || colors.length === 4) {
        const bodyGenerateArt = {
          color_palette_1: await hexToRgb(colors[0]),
          color_palette_2: await hexToRgb(colors[1]),
          color_palette_3: await hexToRgb(colors[2]),
          color_palette_4: colors[3] ? await hexToRgb(colors[3]) : '',
          color_palette_5: '',
        };

        //TODO: precisa ser implementado no new-orchestrator
        generateColorReturn = await OrchestratorColorsService.generateComplementarColors(
          bodyGenerateArt
        );


      }

      console.log(generateColorReturn)
      // const responseBusines = await getBusinessByLogin()

      const hasEmptyField = colors.some((item) => !item);

      if (hasEmptyField) {
        notifyErrorCustom(t('fast_publishing_one_field_is_empty'));
        return;
      }

      let colorsArray = {
        //businessId: responseBusines?.data[0]?.uuid,
        primaryColor: colors[0],
        secondaryColor: colors[1],
        tertiaryColor: colors[2],
        complementaryColor1: colors[3]
          ? colors[3]
          : await rgbToHex(generateColorReturn?.data?.color_palette_4),
        complementaryColor2: colors[4]
          ? colors[4]
          : await rgbToHex(generateColorReturn?.data?.color_palette_5),

        fontTitleId: '',
        //fontTitleByUploaded: '',

        fontSubtitleId: '',
        //fontSubtitleByUploaded:'',

        fontTextId: '',
        //fontTextByUploaded: '',

        fontTitleByUploaded: false,
        fontSubtitleByUploaded: false,
        fontTextByUploaded: false,
      };

      if (branding) {
        colorsArray = {
          primaryColor: colors[0],
          secondaryColor: colors[1],
          tertiaryColor: colors[2],
          complementaryColor1: colors[3]
            ? colors[3]
            : await rgbToHex(generateColorReturn.data.color_palette_4),
          complementaryColor2: colors[4]
            ? colors[4]
            : await rgbToHex(generateColorReturn.data.color_palette_5),
          fontTitleId: branding.fontTitleId,
          //fontTitleByUploaded,

          fontSubtitleId: branding.fontSubtitleId,
          //fontSubtitleByUploaded:'',

          fontTextId: branding.fontTextId,
          //fontTextByUploaded,

          fontTitleByUploaded: branding.fontTitleByUploaded,
          fontSubtitleByUploaded: branding.fontSubtitleByUploaded,
          fontTextByUploaded: branding.fontTextByUploaded,
        };

        const { responseStatus } = await BrandingService.putBranding(
          branding.uuid,
          colorsArray
        );
        //return
      } else {
        await BrandingService.postBranding(colorsArray);
      }

      setStep(STEPS.STEP_PASS_TYPOGRAPHY);
    } else {
      setStep(STEPS.STEP_PASS_NICHE_AND_OBJECTIVE);
    }
  };

  const [exibeColorPallet, setExibeColorPallet] = useState(false);
  const [indexColor, setIndexColor] = useState(0);
  const [indexToRemove, setIndexToRemove] = useState(null);
  const hadleExibeColorPalette = (index) => {
    setExibeColorPallet(true);
    setIndexColor(index);
  };

  const { t } = useTranslation();

  const handleDeleteColor = (index) => {
    setIndexColor(index);
    setColors((prevColors) => {
      // Verifica se o índice está dentro do intervalo do array
      if (index < 0 || index >= prevColors.length) {
        return prevColors; // Retorna o array sem modificá-lo se o índice for inválido
      }

      // Cria um novo array sem o item na posição indicada
      return [
        ...prevColors.slice(0, index), // Elementos antes do índice
        ...prevColors.slice(index + 1), // Elementos após o índice
      ];
    });
    setIndexToRemove(null);
  };

  const handleNavigateMobile = async () => {
    if (isMobile && !isVisualIdentityFlow) {
      setStep(STEPS.STEP_BRANDING);
    } else {
      setStep(STEPS.STEP_PASS_NICHE_AND_OBJECTIVE);
    }
  };
  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      style={{
        width: '100%',
        // height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {isMobile ? (
        <div className={styles.box_step}>
          <div
            style={{
              padding: '0px 14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '65px',
            }}
          >
            <div onClick={() => handleNavigateMobile(false)}>
              <NavigateArrowLeft color={'#0F172A'} />
            </div>
            <p className={styles.title_color_component}>Subtitulo</p>
            <div
              className={styles.box_accept_icon}
              onClick={() => addColor('post', tempColor)}
            >
              <CheckIcon color="#0F172A" size="15px" />
            </div>
          </div>
          <div className={styles.container_colors}>
            {/* {colors?.map((color, index) => (
            <div  key={index}  className={styles.box_color} style={{background: color}} >
              <div  className={styles.color} >{color}</div>
              <div style={{display:'flex', gap: '10px'}}>
                <div className={styles.box_incon} onClick={() => hadleExibeColorPalette(0)}><Dropper color='#000'/></div>
                <div className={styles.box_incon} onClick={() => handleDeleteColor()}><Trash color='#000'/></div>

              </div>
            </div>
            ))
          } */}

            <div className={styles.box_color} style={{ background: colors[0] }}>
              <div className={styles.color}>{colors[0]}</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div
                  className={styles.box_incon}
                  onClick={() => hadleExibeColorPalette(0)}
                >
                  <Dropper color="#000" />
                </div>
                <div
                  className={styles.box_incon}
                  onClick={() => handleDeleteColor(0)}
                >
                  <Trash color="#000" />
                </div>
              </div>
            </div>
            <div className={styles.box_color} style={{ background: colors[1] }}>
              <div className={styles.color}>{colors[1]}</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div
                  className={styles.box_incon}
                  onClick={() => hadleExibeColorPalette(1)}
                >
                  <Dropper color="#000" />
                </div>
                <div
                  className={styles.box_incon}
                  onClick={() => handleDeleteColor(1)}
                >
                  <Trash color="#000" />
                </div>
              </div>
            </div>
            <div className={styles.box_color} style={{ background: colors[2] }}>
              <div className={styles.color}>{colors[2]}</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div
                  className={styles.box_incon}
                  onClick={() => hadleExibeColorPalette(2)}
                >
                  <Dropper color="#000" />
                </div>
                <div
                  className={styles.box_incon}
                  onClick={() => handleDeleteColor(2)}
                >
                  <Trash color="#000" />
                </div>
              </div>
            </div>
            <div className={styles.box_color} style={{ background: colors[3] }}>
              <div className={styles.color}>{colors[3]}</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div
                  className={styles.box_incon}
                  onClick={() => hadleExibeColorPalette(3)}
                >
                  <Dropper color="#000" />
                </div>
                <div
                  className={styles.box_incon}
                  onClick={() => handleDeleteColor(3)}
                >
                  <Trash color="#000" />
                </div>
              </div>
            </div>
            <div className={styles.box_color} style={{ background: colors[4] }}>
              <div className={styles.color}>{colors[4]}</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div
                  className={styles.box_incon}
                  onClick={() => hadleExibeColorPalette(4)}
                >
                  <Dropper color="#000" />
                </div>
                <div
                  className={styles.box_incon}
                  onClick={() => handleDeleteColor(4)}
                >
                  <Trash color="#000" />
                </div>
              </div>
            </div>

            {/* {colors.length < 5 && (
            <div
              className={styles.box_add_color}
              onClick={() => {
                // temColorRef.current = undefined
                // handleColor()
                hadleSelectColor()
                // setColorOrderEnabled(order)
              }}
            >
              <div className={styles.add_color}>
                <Plus  size='50'/>  
              </div>
            </div>
          )} */}
          </div>
        </div>
      ) : (
        <div className={styles.box_step}>
          {/* <PreviousPass steps={stepsArray}/> */}

          <div className={styles.box_page}>
            {/* <p style={{ margin: "0px" }}>
              {t("fast_publishing_color_palette_title")}
            </p> */}
            <div className={styles.box_tittle_content}>
              <h1 >
                {t('fast_publishing_color_palette')}
              </h1>
              <h3>
                {t('fast_publishing_choose_3_at_5_colors')}
              </h3>
            </div>
            <ColorPaletteComponent
              colors={colors}
              setColors={(value) => {
                setColors(value);
                changesStep.current = true;
              }}
            />
          </div>
          {/* <div className={styles.box_button}>
          <button
            className={styles.back_button}
            onClick={() => handleNavigate('back')}
          >
            {t("back_buttom")}
          </button>
          <button
            className={styles.next_button}
            onClick={() => handleNavigate('next')}
          >
            {t('next_buttom')}
          </button>

        </div> */}
          <FooterNaviBar
            back={() => handleNavigate('back')}
            next={() => handleNavigate('next')}
          />
        </div>
      )}

      {exibeColorPallet && (
        <ColorPaletteComponentMobile
          colors={colors}
          setColors={setColors}
          setExibeColorPallet={setExibeColorPallet}
          indexColor={indexColor}
        />
      )}
    </motion.div>
  );
}

export default StepColorPalette;

StepColorPalette.propTypes = {
  setStep: PropTypes.func,
  colors: PropTypes.array,
  setColors: PropTypes.func,
  businessAccountData: PropTypes.object,
  changesStep: PropTypes.object,
}